{
    "DataTable_AreYouSure": "Weet u zeker dat u het volgende wilt verwijderen? \n \n **{}**",
    "NAME": "LanguageDataTable",
    "DataTable_RowsPerPage": "Rijen per pagina",
    "DataTable_Of": "{}-{} of {}",
    "DataTable_Next": "Volgende pagina",
    "DataTable_Previous": "Vorige pagina",
    "DataTable_OfMoreThan": "{}-{} van meer dan {}"
}